import { DeleteServiceReviewUseCase, DeleteServiceReviewParams } from "./index"
import { ServiceReviewsRepository } from "../../../repositories/serviceReviewsRepository"

export class DeleteServiceReviewUseCaseImpl implements DeleteServiceReviewUseCase {
	private _serviceReviewsRepository: ServiceReviewsRepository

	constructor({ ServiceReviewsRepository }: { ServiceReviewsRepository: ServiceReviewsRepository }) {
		this._serviceReviewsRepository = ServiceReviewsRepository
	}

	async exec(params: DeleteServiceReviewParams): Promise<void> {
		return await this._serviceReviewsRepository.deleteServiceReview(params.reviewId)
	}
}
